import { AxiosResponse } from 'axios';
import { botList, botUsageStats } from '@/api/bot';
import { AppError } from '@/errors/appError';
import { baseListService, isRequestCanceled } from '@/services/baseService';
import { IListParams } from '@/types';
import { IBotApiListResponse, IBotFilters } from '@/types/bot';
import { IBotUsageStatsApiResponse, IBotUsageStatsFilters } from '@/types/botUsageStats';

export const botService = {
    async list(params: IListParams<IBotFilters>): Promise<AxiosResponse<IBotApiListResponse>> {
        try {
            return await baseListService<IBotApiListResponse>(botList, params);
        } catch (e) {
            if (isRequestCanceled(e)) throw e;
            console.error('Bot API Error:', e);
            throw new AppError('Unable to load bot list, request error', { cause: e });
        }
    },

    async usageStats(params: IListParams<IBotUsageStatsFilters>): Promise<AxiosResponse<IBotUsageStatsApiResponse>> {
        try {
            return await baseListService<IBotUsageStatsApiResponse>(botUsageStats, {
                ...params,
                requestKey: params.requestKey ?? 'bot-usage-stats',
            });
        } catch (e) {
            if (isRequestCanceled(e)) throw e;
            console.error('Bot Usage Stats API Error:', e);
            throw new AppError('Unable to load bot usage stats, request error', { cause: e });
        }
    },
};
